import { APIPost, Stream } from './http';
import { IDownloadFile, IFetchData } from '../_types/post';
import { report_response, report_historical_query, create_over_time, create_over_time_supplemental, QueryDefinition } from '../_types/reports';
import { freeze_over_time, freeze_over_time_supplemental } from '../_types/reports';
import { cancel_over_time, cancel_over_time_supplemental } from '../_types/reports';
import { net_over_time, net_over_time_supplemental } from '../_types/reports';
import { ColumnDefinition, SearchQuery, SearchQueryResult } from '../_types/search';


export const FreezeOverTime = async (query: report_historical_query): Promise<report_response<freeze_over_time, freeze_over_time_supplemental>> => {

    // let abc = Moment.utc().format("YYYY-MM-DDThh:mm:ss");
    

    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/reporting/freezes",
        ...query
    };
    

    let result = await APIPost<report_response<freeze_over_time, freeze_over_time_supplemental>>(post);


    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    if (!result) {
        return {
            commentary: [], 
            data: [],
            supplemental: { future_unfreeze: null},
            disclaimer: [],
            lowest: 0,
            highest: 0,
            current: 0
        }
    } 

    result.lowest = result.data[0].offSetFromToday;
    
    result.highest = result.data[result.data.length - 1].offSetFromToday;
    result.current = 0;
    
    return result;

};

export const CancelOverTime = async (query: report_historical_query): Promise<report_response<cancel_over_time, cancel_over_time_supplemental>> => {

    // let abc = Moment.utc().format("YYYY-MM-DDThh:mm:ss");
    

    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/reporting/cancels",
        ...query
    };
    

    let result = await APIPost<report_response<cancel_over_time, cancel_over_time_supplemental>>(post);


    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    if (!result) {
        return {
            commentary: [], 
            data: [],
            supplemental: { },
            disclaimer: [],
            lowest: 0,
            highest: 0,
            current: 0
        }
    } 

    result.lowest = result.data[0].offSetFromToday;
    
    result.highest = result.data[result.data.length - 1].offSetFromToday;
    result.current = 0;
    
    return result;

};

export const CreateOverTime = async (query: report_historical_query): Promise<report_response<create_over_time, create_over_time_supplemental>> => {

    // let abc = Moment.utc().format("YYYY-MM-DDThh:mm:ss");
    

    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/reporting/creates",
        ...query
    };
    

    let result = await APIPost<report_response<create_over_time, create_over_time_supplemental>>(post);


    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    if (!result) {
        return {
            commentary: [], 
            data: [],
            supplemental: { },
            disclaimer: [],
            lowest: 0,
            highest: 0,
            current: 0
        }
    } 

    result.lowest = result.data[0].offSetFromToday;
    
    result.highest = result.data[result.data.length - 1].offSetFromToday;
    result.current = 0;
    
    return result;

}

export const NetOverTime = async (query: report_historical_query): Promise<report_response<net_over_time, net_over_time_supplemental>> => {

    // let abc = Moment.utc().format("YYYY-MM-DDThh:mm:ss");
    

    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: "/reporting/net",
        ...query
    };
    

    let result = await APIPost<report_response<net_over_time, net_over_time_supplemental>>(post);

    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    if (!result) {
        return {
            commentary: [], 
            data: [],
            supplemental: { },
            disclaimer: [],
            lowest: 0,
            highest: 0,
            current: 0
        }
    } 

    result.lowest = result.data[0].offSetFromToday;
    
    result.highest = result.data[result.data.length - 1].offSetFromToday;
    result.current = 0;
    
    return result;

};

export const GetQueryColumns = async (query_cn: string): Promise<ColumnDefinition[]> => {
    let post: IFetchData = {
        authorize: true,
        method:"GET",
        refresh: false,
        service: "ewapi",
        relay_to: `/reporting/ListSearchColumns/${query_cn}` 
    };
    

    let result = await APIPost<ColumnDefinition[]>(post);

    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    if (!result) {
        return [];
    } 
    
    return result;
}

export const ExportQuery = async (query: SearchQuery, fileName: string): Promise<IDownloadFile | null> => {
    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: `/reporting/Search`,
        ...query
    };
    

    let result = await Stream(post, fileName);

    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    
    return result;
}

export const ExecuteQuery = async (query: SearchQuery): Promise<SearchQueryResult> => {
    let post: IFetchData = {
        authorize: true,
        method:"POST",
        refresh: false,
        service: "ewapi",
        relay_to: `/reporting/Search`,
        ...query
    };
    

    let result = await APIPost<SearchQueryResult>(post);

    // let result: ISearchResult[] = [
    //     {
    //         key: "1", value: "Test wash abc"
    //     }, {
    //         key: "2", value: "Test wash def"
    //     }
    // ];

    // return Promise.resolve(result);
    
    return result as SearchQueryResult;
}

export const GetDefaultSearchQuery = (qDef: QueryDefinition, columns: ColumnDefinition[], location_id: number | null): SearchQuery => {
    
    let cn = qDef.cn;
    let newQuery: SearchQuery =
    {
        query_cn: qDef.cn,
        queryParams: [],
        columns: [],
        PageSize: 50,
        StartFromKeys: [],
        Reverse: false,
        KeyFields: [],
        Page: 0,
        query_uuid: null
    };
  

    // r.forEach(g => newQuery.columns.push(g.column_cn));
    columns.forEach(g => {
        if (g.include) {
        newQuery.columns.push(g.column_cn);
        }
    });

    let primary = columns.find(g => g.primary);    
    if (primary) {
        newQuery.columns.push(primary.column_cn);
        newQuery.KeyFields?.push(primary.column_cn);
    }

    switch (cn) {
        case "location":
        
            if (location_id) {
                newQuery.queryParams.push({
                    column_cn: "servicelocation.id",
                    comparison: "equals",
                    values: [ location_id.toString() ]
                });
            }
            break;
        case "membership":
                if (location_id) {
                    
                    newQuery.queryParams.push({
                        column_cn: "primarymembership.location_id_hidden",
                        comparison: "equals",
                        values: [ location_id.toString() ]
                    });
                }
                break;
    }

  return newQuery;

}
